var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-colum align-center",staticStyle:{"height":"100%","min-height":"62px"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',[_vm._v(_vm._s(_vm.createdAt))]),(_vm.createdByShown)?_c('div',[_vm._v(_vm._s(_vm.createdBy))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }